import { useContext } from 'react'
import { Box, Button, Spinner, Spacer } from '@telus-uds/components-web'
import { useSearchParam } from 'react-use'

import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import useCart from '../../../hooks/useCart'
import { getFlowType, FLOW_TYPES } from '../../../utils/cart'
import { checkIsCartValid } from '../../../utils/cartValidations'
import { Container } from './styles'
import ReserveInStore from './ReserveInStore'
import useFulfillment from './useFulfillment'
import EmailYourCartLink from './EmailYourCartLink'
import { getCheckoutUrl } from './utils'

const PriceSummaryTopActions = () => {
  const translate = useTranslate()
  const linkType = useSearchParam('linktype')
  const { lang, prov } = useContext(localeContext)
  const { cart, isUpdatingItemFulfillment } = useCart()
  const triggerFulfillment = useFulfillment()
  const cartValidationStatus = checkIsCartValid({ cart, prov, linkType })
  const queryParams = window.location.search

  const handleButtonClick = (e) => {
    e.preventDefault()
    // if the cart is valid
    if (cartValidationStatus.isValid) {
      if (getFlowType(cart) === FLOW_TYPES.RESERVATION) {
        triggerFulfillment({
          method: 'SHIPMENT',
          deferPayment: false
        })
      } else {
        window.location.assign(getCheckoutUrl(cart, queryParams, lang))
      }
    } else {
      // eslint-disable-next-line no-undef
      window.scrollTo(0, 0)
    }
  }

  return (
    <Spinner show={Boolean(isUpdatingItemFulfillment)} label={translate('spinner')}>
      <Container>
        <Box top={3}>
          <Button
            variant={{ priority: 'high', width: 'full' }}
            onPress={handleButtonClick}
            testID="price-summary-checkout"
          >
            {translate('priceSummary.checkout')}
          </Button>
          <Spacer space={3} />
          <ReserveInStore
            triggerFulfillment={triggerFulfillment}
            isCartValid={cartValidationStatus.isValid}
            cart={cart}
          />
          <EmailYourCartLink cart={cart} />
          <Spacer space={3} />
        </Box>
      </Container>
    </Spinner>
  )
}

export default PriceSummaryTopActions
